import { digitsOnly } from "../../shared/validators/digits-only.validator";
import { indianPhoneNumber } from "../../shared/validators/indian-phone-number.validator";

export const VALIDATOR_KEYS = {
    required: "required",
    forbiddenName: "forbiddenName",
    email: "email",
    digitsOnly: "digitsOnly",
    leadingTrailingSpace: "leadingTrailingSpace",
    invalidPincode: "invalidPincode",
    indianPhoneNumber: "indianPhoneNumber",
} as const;

export type ValidatorKey = (typeof VALIDATOR_KEYS)[keyof typeof VALIDATOR_KEYS];
